export const ActionTypes = {
    GET_SEARCH_RESULT: "GET_SEARCH_RESULT",
    SET_SEARCH_TEXT: "SET_SEARCH_TEXT",
    SET_LOADER: "SET_LOADER",
    RESET_STATE: 'RESET_STATE',
    SET_DOCUMENT_HEADERS: 'SET_DOCUMENT_HEADERS'
};
